class s{constructor(){this.registry=[]}get behaviors(){return[...this.registry]}register(e){this.behaviors.some(i=>i===e)||this.registry.push(e)}}export{s as BehaviorRegistry};
